export default __webpack_public_path__ + "static/3-3751014f2c3458679a0ff00d8005636e.jpg";